import { useCallback, useMemo } from 'react'

import { useOrganisationProfileContext } from '../context/OrganisationProfileContext'
import {
  ORGANISATION_PROFILE_NAMESPACE,
  TranslationKey,
  organisationProfileI18n,
} from '../i18n/i18n'

type Translate = (key: string, values?: Record<string, unknown>) => string

export const useTranslation = () => {
  const { locale } = useOrganisationProfileContext()

  const fixedT = useMemo(
    () =>
      organisationProfileI18n.getFixedT(
        locale,
        ORGANISATION_PROFILE_NAMESPACE
      ) as unknown as Translate,
    [locale]
  )

  const t = useCallback(
    (key: TranslationKey, values?: Record<string, unknown>) =>
      fixedT(key, values),
    [fixedT]
  )

  return { t, locale }
}
